import { useSnackbar } from '../../hooks/use_snackbar'

const AssetIdentifier = ({ uuid }) => {
  const { addMessage } = useSnackbar()

  if (!uuid) return null

  const copyAssetId = async () => {
    try {
      await navigator.clipboard.writeText(uuid)
      addMessage('Asset ID copied')
    } catch {
      addMessage('Couldn’t copy asset ID', 'error')
    }
  }

  return (
    <button
      type='button'
      onClick={copyAssetId}
      className='cursor-pointer rounded-sm font-mono text-xs hover:text-[color:var(--cs-color-foreground-primary)] focus-visible:outline-none focus-visible:shadow-[var(--cs-focus-ring-default-sm)]'
      title='Copy asset ID'
    >
      {uuid}
    </button>
  )
}

export default AssetIdentifier
